import { useDispatch, useSelector, useStore } from "react-redux"
import type { RootState, AppDispatch, AppStore } from "./store"

export const useAppDispatch = useDispatch.withTypes<AppDispatch>()
export const useAppStore: () => AppStore = useStore
export const useAppSelector = useSelector.withTypes<RootState>()
